import React, {PureComponent} from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import { isEmpty } from '../../../../shared/services/lodashInJS.js';

import {generate} from '../../../routes.js';
import {isAdmin} from '../../../../shared/services/userService.js';
import connectPagination from '../HOC/Pagination.js';
import Pagination from '../../../components/Pagination/Pagination.jsx';

import './SearchResultsPaginated.scss';

class SearchResultsPaginated extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    renderResults: PropTypes.func.isRequired,
    results: PropTypes.array.isRequired,
    routeName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
    loading: false,
  };

  generatePaginationLink = (page) => generate({
    name: this.props.routeName,
    search: this.props.flattenSearchObject({
      ...this.props.searchQuery,
      page: page + 1
    })
  });

  render() {
    if (this.props.loading) {
      return null;
    }

    return (
      <div className={`${this.props.className} results-paginated`}>
        {this.props.renderResults(this.props.results)}
        <div className="d-flex justify-content-center">
          <Pagination
            current={this.props.pagination.currentPage - 1}
            pagesCount={this.props.pagination.pageCount}
            generateLink={this.generatePaginationLink}
          />
        </div>
        {isEmpty(this.props.results) &&
        <div className="row">
          <div className="text-center col-xxl-8 mx-auto bg-white bd-gray-200 p-5 my-5">
            <h5>Aucun résultat n'a été trouvé</h5>
          </div>
        </div>
        }
      </div>
    );
  }
}

export default connectPagination()(
  connect(
    state => ({
      currentUser: state.currentUser.user,
      isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
    })
  )(SearchResultsPaginated)
);